import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '@s/Button';
import { setShowBestAvailablePicker, setShowPyosPicker, addAlert } from '../../../actions/ui';
import { submitReserveCoupon } from '../../../actions/reservedSeating';
import {
  hasReserveCoupon,
  onlyShowBestAvailable,
  isPyos,
  hideBestAvailable
} from '../../../selectors/reserved-seating';
import { reservationActive } from '../../../selectors/reservation';
import Coupon from '../../coupon/components/Coupon';
import Translation from '@s/Translation';
import { get_custom_get_seat_message } from '../../../selectors/event';
import EmbedFooter from '../../../components/EmbedFooter';
import { withNavigation } from '@b/helpers/withNavigation';
import { isDynamicListing } from '@b/checkout/selectors/dynamic-listing';
import { getListingSoldOutMessage } from '../../../selectors/ui';

class BestAvailableOrPyosPicker extends Component {

    _mounted = false;

    state = {
        doCoupon: false,
        couponCode: "",
        couponLoading: false,
        couponError: false,
    }

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    setStateIfMounted = args => {
        if (this._mounted) {
            this.setState(args);
        }
    }

    cancelCoupon = () => {
        this.setStateIfMounted({
            doCoupon: false,
            couponCode: '',
            couponError: false,
        });
    }

    submitCoupon = async () => {
        this.setStateIfMounted({couponLoading: true, couponError: false});
        await this.props.submitReserveCoupon(this.state.couponCode);
        this.setStateIfMounted({couponLoading: false});
        if (this.props.reservation.hasReserveCoupon) {
            this.props.addAlert('checkout__reserve_code_applied', 'success');
            this.setStateIfMounted({doCoupon: false});
        } else {
            this.setStateIfMounted({couponError: true})
        }
    }

    getBestAvailableButtonText = () => {
      if(this.props.bestAvailableButtonText) {
        return this.props.bestAvailableButtonText;
      }

      return <Translation>{'checkout__find_best_available'}</Translation>
    }

    render() {

        if (this.state.doCoupon) {
            return (
                <Coupon
                    asOverlay={false}
                    onCancelCoupon={this.cancelCoupon}
                    code={this.state.couponCode}
                    onCodeChange={couponCode => {this.setStateIfMounted({couponCode})}}
                    onCodeSubmit={this.submitCoupon}
                    showError={this.state.couponError}
                    title={'checkout__enter_reservation_code'}
                    disabled={this.state.couponLoading || this.props.taggableCouponLoading}
                />
            );
        }

        const onShowPyosPicker = () => {
          this.props.navigate('/');
          this.props.setShowPyosPicker(true);
        }

        const onShowBestAvailablePicker = () => {
          this.props.navigate('/')
          this.props.setShowBestAvailablePicker(true);
        }

        return (
            <div className="event-inventory__footer-wrap">
              <div className="tickets__seated-method-picker event-inventory__footer">
                  <div className="checkout-form__footer">
                    {this.props.showSoldOut ? (
                      <div className="sold-out-message">{this.props.soldOutMessage}</div>
                    ) : (
                      <>
                        {!this.props.onlyShowBestAvailable && this.props.isPyos && (
                          <Button
                            onClick={onShowPyosPicker}
                            className="button--primary button--full add-to-cart__button"
                            loading={this.props.loading}
                            data-testid="get-tickets"
                          >
                            {this.props.custom_get_seat_message} {!this.props.custom_get_seat_message && (<Translation>{'checkout__select_seats'}</Translation>)}
                          </Button>
                        )}
                        {!this.props.hideBestAvailable && (
                          <Button
                            onClick={onShowBestAvailablePicker}
                            className="button button--full"
                            loading={this.props.loading}
                          >
                            {this.getBestAvailableButtonText()}
                          </Button>
                        )}
                        {this.props.hasReserveCoupon && !this.props.reservationActive && (
                          <Button onClick={() => {this.setStateIfMounted({doCoupon: true})}} className="button button--full button--clear">
                            <Translation>{'checkout__have_reserved_seat_code'}</Translation>
                          </Button>
                        )}
                      </>
                    )}
                  </div>
              </div>
              {!this.props?.isDynamic && (<EmbedFooter />)}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        hasReserveCoupon: hasReserveCoupon(state),
        reservation: state.reservation,
        reservationActive: reservationActive(state),
        taggableCouponLoading: state.couponTag.taggableCouponLoading,
        custom_get_seat_message: get_custom_get_seat_message(state),
        hideBestAvailable: hideBestAvailable(state) && !onlyShowBestAvailable(state),
        disableBestAvailable: state.ui.disableBestAvailable,
        bestAvailableButtonText: state.ui.bestAvailableButtonText,
        onlyShowBestAvailable: onlyShowBestAvailable(state),
        isPyos: isPyos(state),
        isDynamic: isDynamicListing(state),
        showSoldOut: state.ui.listingSoldOut,
        soldOutMessage: getListingSoldOutMessage(state),
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setShowBestAvailablePicker,
        setShowPyosPicker,
        submitReserveCoupon,
        addAlert,
    }, dispatch);
};

export default withNavigation(connect(mapStateToProps, mapDispatchToProps)(BestAvailableOrPyosPicker));
